import type { ComponentProps, ReactNode } from 'react';

import { IconButton } from '../buttons/icon-button';

import { Spinner } from './spinner';

const SPINNER_SIZE = 16;

export type LoadingIconButtonProps = Readonly<
  Omit<ComponentProps<typeof IconButton>, 'children'> & {
    icon: ReactNode;
    isLoading?: boolean;
  }
>;

export const LoadingIconButton = ({
  icon,
  isLoading = false,
  disabled = false,
  ...rest
}: LoadingIconButtonProps) => {
  const isDisabled = disabled || isLoading;
  const content = isLoading ? <Spinner size={SPINNER_SIZE} color='inherit' /> : icon;

  return (
    <IconButton {...rest} disabled={isDisabled}>
      {content}
    </IconButton>
  );
};

LoadingIconButton.displayName = 'LoadingIconButton';
